import React from 'react';
import ReactDOM from 'react-dom';

import './core/formBuilder';
import './styles.scss';

import RootBrowser from './components/Root';

import * as serviceWorker from './serviceWorker';

ReactDOM.render(<RootBrowser />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
